import React from 'react';
import propTypes from 'prop-types';
import { CANVAS_REPORTS } from '@das/canvas-common/src/const';
import menu from 'open-iconic/svg/menu.svg';

import ability from 'app/Can/ability';
import ContextMenu from 'app/ContextMenu/components/ContextMenu';
import { visitReports } from 'app/Router/actions';
import { Link } from 'utils/store/thirdPartyConnectToCanvasStore';

const makeReportLink = ({ displayName, name }) => (
  <Link className="text-body text-decoration-none" target="_blank" to={visitReports(name)}>
    {displayName}
  </Link>
);

const reportLinks = {
  [CANVAS_REPORTS.ARCHIVED_CONTENT]: makeReportLink({
    displayName: 'Report of Archived Content',
    name: CANVAS_REPORTS.ARCHIVED_CONTENT
  }),
  [CANVAS_REPORTS.CONTENT_BY_LINKS]: makeReportLink({
    displayName: 'Content Link URL Search Report',
    name: CANVAS_REPORTS.CONTENT_BY_LINKS
  }),
  [CANVAS_REPORTS.SCHEDULED_CONTENT]: makeReportLink({
    displayName: 'Report of Scheduled Pages and Content Sizes',
    name: CANVAS_REPORTS.SCHEDULED_CONTENT
  })
};

/**
 * renders hamburger menu for Canvas
 * @returns {React.Component} Canvas Menu component
 */
const CanvasMenu = ({ permissions }) => {
  const actions = Object.keys(reportLinks)
    .filter(report =>
      ability.can({
        permissions,
        report,
        read: true
      })
    )
    .map(report => ({
      action: report,
      text: reportLinks[report]
    }));

  return <ContextMenu icon={menu} actions={actions} popoverPlacement="bottom-end" rem={1.5} />;
};

CanvasMenu.propTypes = {
  permissions: propTypes.shape({
    folders: propTypes.shape({
      read: propTypes.arrayOf(propTypes.string),
      edit: propTypes.arrayOf(propTypes.string)
    }),
    components: propTypes.shape({
      read: propTypes.arrayOf(propTypes.string),
      edit: propTypes.arrayOf(propTypes.string)
    })
  }).isRequired
};

export default CanvasMenu;
